export const SUPPORTED_MIME_TYPES = {
  docs: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ],
  images: ['image/jpeg', 'image/png', 'image/heif', 'image/heic'],
  videos: ['video/mp4', 'video/mpeg', 'video/quicktime'],
}

export const getBlobFromUri = async (uri: string): Promise<Blob> => {
  const response = await fetch(uri)
  return response.blob()
}

export const getFilenameFromBlob = (blob: Blob): string => {
  const extension = blob.type.split('/')[1] // e.g., 'jpeg', 'png'
  return `${Date.now()}.${extension}`
}
